const entry = resolve => {
  require.ensure([], () => {
    resolve(require('../views/freight/invoiceEntry.vue'))
  }, 'freight')
}
  //选择行程
  const appScheduleList = resolve => {
    require.ensure([], () => {
      resolve(require('../views/freight/invoice/scheduleList.vue'))
    }, 'freight')
  }
  //开发票
  const appElecPage = resolve => {
    require.ensure([], () => {
      resolve(require('../views/freight/invoice/invoiceElecPage.vue'))
    }, 'freight')
  }
  //开发票
  const appPaperPage = resolve => {
    require.ensure([], () => {
      resolve(require('../views/freight/invoice/invoicePaperPage.vue'))
    }, 'freight')
  }
  //开发票成功
  const appInvoiceSuccess = resolve => {
    require.ensure([], () => {
      resolve(require('../views/freight/invoice/invoiceSuccess.vue'))
    }, 'freight')
  }

  //开票中
  const InvoicingSuccess = resolve => {
    require.ensure([], () => {
      resolve(require('../views/freight/invoice/InvoicingSuccess.vue'))
    }, 'freight')
  }

  //零担发票抬头列表
  const lookUpList = resolve => {
    require.ensure([], () => {
      resolve(require('../views/freight/invoiceLookUp/lookUpList.vue'))
    }, 'freight')
  }
  //零担发票抬头添加
  const addLookUp = resolve => {
    require.ensure([], () => {
      resolve(require('../views/freight/invoiceLookUp/addLookUp.vue'))
    }, 'freight')
  }

  //零担发票历史
  const historyList = resolve => {
    require.ensure([], () => {
      resolve(require('../views/freight/invoiceHistory/historyList.vue'))
    }, 'freight')
  }
  //零担发票历史外层
  const outerLayer = resolve => {
    require.ensure([], () => {
      resolve(require('../views/freight/invoiceHistory/outerLayer.vue'))
    }, 'freight')
  }

  //零担电子发票
  const electronicDetails = resolve => {
    require.ensure([], () => {
      resolve(require('../views/freight/invoiceDetails/electronicDetails.vue'))
    }, 'freight')
  }

  //重新发送行程单
  const send = resolve => {
    require.ensure([], () => {
      resolve(require('../views/freight/invoiceDetails/send.vue'))
    }, 'freight')
  }

  //发票详情
  const invoiceDetail = resolve => {
    require.ensure([], () => {
      resolve(require('../views/freight/invoice/invoiceDetail.vue'))
    }, 'freight')
  }
  //支付返回中转页面
  const transit = resolve => {
    require.ensure([], () => {
      resolve(require('../views/freight/invoice/transit.vue'))
    }, 'freight')
  }

  //地址列表
  const addressList = resolve => {
    require.ensure([], () => {
      resolve(require('../views/freight/invoice/addressList.vue'))
    }, 'freight')
  }
  //添加地址
  const addAddress = resolve => {
    require.ensure([], () => {
      resolve(require('../views/freight/invoice/addAddress.vue'))
    }, 'freight')
  }
  //开票规则
  const appInvoiceRule = resolve => {
    require.ensure([], () => {
      resolve(require('../views/freight/invoice/invoiceRule.vue'))
    }, 'freight')
  }
  //专票认证
  const appInvoiceAuth = resolve => {
    require.ensure([], () => {
      resolve(require('../views/freight/invoice/invoiceAuth.vue'))
    }, 'freight')
  }
  //专票认证书
  const appAuthBook = resolve => {
    require.ensure([], () => {
      resolve(require('../views/freight/invoice/authbook.vue'))
    }, 'freight')
  }
  //零担更多发票信息
  const papEleMore = resolve => {
    require.ensure([], () => {
      resolve(require('../views/freight/invoiceDetails/papEleMore.vue'))
    }, 'freight')
  }

  //零担资质认证审核
  const certification = resolve => {
    require.ensure([], () => {
      resolve(require('../views/freight/invoiceCertification/certification.vue'))
    }, 'freight')
  }
  //零担资质认证审核
  const appInvoiceDesc = resolve => {
    require.ensure([], () => {
      resolve(require('../views/freight/invoiceDesc/index.vue'))
    }, 'freight')
  }
  //零担资质认证审核
  const invoiceMiddle = resolve => {
    require.ensure([], () => {
      resolve(require('../views/freight/invoice/invoiceMiddle.vue'))
    }, 'freight')
  }

  const deliverDetail = resolve=>{
    require.ensure([], () => {
      resolve(require('../views/freight/invoiceDetails/deliverDetail.vue'))
    }, 'freight')
  }

  export default [
    {path: '/entry', component: entry, meta: {title: '发票'}},
    {path: '/appScheduleList', component: appScheduleList, meta: {title: '选择行程'}},
    {path: '/appInvoiceSuccess', component: appInvoiceSuccess, meta: {title: '开票成功'}},
    {path: '/InvoicingSuccess', component: InvoicingSuccess, meta: {title: '开票成功'}},
    {path: '/addressList', component: addressList, meta: {title: '更多地址'}},
    {path: '/addAddress', component: addAddress, meta: {title: '添加地址'}},
    {path: '/appInvoiceRule', component: appInvoiceRule, meta: {title: '开票规则'}},
    {path: '/appInvoiceAuth', component: appInvoiceAuth, meta: { title: '开票资质认证申请' } },
    {path: '/appAuthBook', component: appAuthBook, meta: { title: '开票资质确认书' } },
    {path: '/appInvoiceDesc', component: appInvoiceDesc, meta: { title: '开票说明' } },
    // {path: '/passport', component: invoiceMiddle, meta: { title: '用户认证' } },
    {path: '/send', component: send, meta: { title: '电子开票详情' } },
    {path: '/lookUpList', component: lookUpList, meta: {title: '抬头管理'}},
    {path: '/addLookUp', component: addLookUp, meta: {title: '添加抬头'}},
    {path: '/historyList', component: historyList, meta: {title: '同期申请发票'}},
    {path: '/outerLayer', component: outerLayer, meta: {title: '开票历史'}},
    {path: '/electronicDetails', component: electronicDetails, meta: {title: '电子开票详情'}},
    {path: '/appInvoiceDetail', component: invoiceDetail, meta: {title: '发票详情'}},
    {path: '/transit', component: transit, meta: {title: '开票历史'}},
    {path: '/papEleMore', component: papEleMore, meta: {title: ''}},
    {path: '/certification', component: certification, meta: {title: '开票资质认证'}},
    {path: '/deliverDetail', component: deliverDetail, meta: {title: '纸质专票快递详情'}},
    {path: '/appElecPage', component: appElecPage, meta: {title: '开具电子发票'}},
    {path: '/appPaperPage', component: appPaperPage, meta: {title: '开具纸质专票'}},
  ]



// WEBPACK FOOTER //
// ./src/router/freight.js